<script>
import HubHelper from "@/services/hub";
import utils from "@/services/utils";
import IconBeepiz from "@/components/icons/Beepiz";
import IconSfrdati from "@/components/icons/Sfrdati";
import IconCatsafe from "@/components/icons/Catsafe";
import { Icon } from "@iconify/vue2";

export default {
  name: "UiNavbarHub",
  components: {
    IconBeepiz,
    IconSfrdati,
    IconCatsafe,
    Icon,
  },
  computed: {
    hubHelper() {
      return HubHelper;
    },
    className() {
      return "d-flex flex-column justify-content-center align-items-center tw-gap-2 tw-p-2 flex-1 aspect-1 rounded-md hover:bg-gray-100";
    },
    isThemeSfr() {
      return utils.isThemeSfr();
    },
    isThemeCatsafe() {
      return utils.isThemeCatsafe();
    },
    managerUrl() {
      if (utils.isThemeSfr()) return HubHelper.getLink("sfrManager")
      if (utils.isThemeCatsafe()) return HubHelper.getLink("catsafeManager")
      return HubHelper.getLink("manager")
    },
    supportUrl() {
      if (utils.isThemeSfr()) return HubHelper.getLink("sfrSupport")
      if (utils.isThemeCatsafe()) return HubHelper.getLink("catsafeSupport")
      return HubHelper.getLink("support")
    }
  },
};
</script>
<template>
  <nav class="d-flex tw-gap-0.5 list-unstyled text-gray-600">
    <a
      v-if="isThemeSfr"
      :href="hubHelper.getLink('sfrBeepiz')"
      :class="className"
      class="bg-gray-100"
    >
      <IconSfrdati class="size-8" />
      <span>{{ $t("hub.sfr") }}</span>
    </a>
    <a
      v-else-if="isThemeCatsafe"
      :href="hubHelper.getLink('catsafeBeepiz')"
      :class="className"
      class="bg-gray-100"
    >
      <IconCatsafe class="size-8" />
      <span>{{ $t("hub.catsafe") }}</span>
    </a>
    <a
      v-else
      :href="hubHelper.getLink('beepiz')"
      :class="className"
      class="bg-gray-100"
    >
      <IconBeepiz class="size-8" />
      <span>{{ $t("hub.beepiz") }}</span>
    </a>
    <a
      :href="managerUrl"
      :class="className"
    >
      <Icon icon="material-symbols:groups" class="size-8" />
      <span>{{ $t("hub.manager") }}</span>
    </a>
    <a
      :href="supportUrl"
      :class="className"
    >
      <Icon icon="material-symbols:support" class="size-8" />
      <span>{{ $t("hub.support") }}</span>
    </a>
  </nav>
</template>
